define('models/linkedcards/linkedcard_collection',["backbone", "models/linkedcards/linkedcard"], function (Backbone, LinkedCard) {
	var LinkedCardList = Backbone.Collection.extend({
		model: LinkedCard,
		url: function () {
			return this.instanceURL;
		},
		initialize: function (options) {
			options = options || {};
			this.instanceURL = options.instanceURL;
			this.includeSpendingAccount = options.SA;
		},
	});
	return LinkedCardList;
});

